{
  "languages": {
    "en": "English",
    "ko": "Korean",
    "zh-cn": "Chinese Simplified",
    "zh-tw": "Chinese Traditional",
    "ja": "Japanese",
    "es": "Spanish",
    "fr": "French",
    "vi": "Vietnamese",
    "id": "Indonesian",
    "th": "Thai",
    "ru": "Russian",
    "de": "German",
    "pt": "Portuguese"
  },
  "countries": {
    "us": "United States",
    "gb": "United Kingdom",
    "au": "Australia",
    "ca": "Canada",
    "sg": "Singapore",
    "in": "India",
    "es": "Spain",
    "mx": "Mexico",
    "ar": "Argentina",
    "cl": "Chile",
    "co": "Colombia",
    "pe": "Peru",
    "pt": "Portugal",
    "br": "Brazil",
    "kr": "South Korea",
    "vn": "Vietnam",
    "jp": "Japan",
    "cn": "China",
    "tw": "Taiwan",
    "ru": "Russia",
    "th": "Thailand",
    "id": "Indonesia",
    "fr": "France",
    "de": "Germany",
    "xx": "Stateless"
  },
  "onboarding": {
    "greeting": "Hi! I'm MooWoo.",
    "question": "What language do you speak?",
    "select": "Select your language",
    "search": "Search languages...",
    "continue": "Continue",
    "skip": "Skip for now",
    "no_languages": "No languages found"
  },
  "auth": {
    "title": "Welcome to MooWoo",
    "subtitle": "Enter your email to get started",
    "email_placeholder": "you@example.com",
    "send_code": "Send code",
    "sending": "Sending...",
    "code_placeholder": "Enter the 6-digit code",
    "code_sent": "We sent a code to {{email}}",
    "code_sent_check_spam": "Didn't receive the email? Please check your spam or promotions tab.",
    "verify": "Verify & continue",
    "verifying": "Verifying...",
    "resend": "Resend code",
    "resend_wait": "Resend ({{seconds}}s)",
    "change_email": "Use a different email",
    "error_invalid_email": "Please enter a valid email address.",
    "error_invalid_code": "The code is incorrect or expired. Please try again.",
    "error_code_incomplete": "Please enter all 6 digits of the verification code.",
    "error_cooldown_wait": "Please wait a moment before trying again.",
    "error_deletion_cooldown": "This account was deleted. You can sign up again with this email one year after deletion.",
    "error_generic": "Something went wrong. Please try again.",
    "google_login_failed": "Failed to sign in with Google. Please try again.",
    "google_login_cancelled": "Google sign-in was cancelled.",
    "google_login_error": "An error occurred during Google sign-in. Please try again.",
    "inapp_browser_google_restriction": "Google sign-in is not supported inside this app. Please continue with email, or open this page in an external browser like Chrome or Safari.",
    "inapp_google_desc": "Google sign-in is not supported inside this app.",
    "open_in_browser": "Open in Browser",
    "copy_link": "Copy Link",
    "copy_link_copied": "Copied!",
    "inapp_ios_guide": "Open the menu on this screen and choose 'Open in Safari' or 'Open in another browser'. You can also copy the link below and paste it into Safari.",
    "force_google_login": "Try Google sign-in anyway",
    "copy_manual_guide": "Copy the link below and paste it into your browser:",
    "inapp_open_failed": "The browser didn't open. Copy the link below and open it in your browser.",
    "inapp_use_browser": "Google sign-in works only in a browser.",
    "inapp_generic_guide": "Open the menu on this screen and choose 'Open in browser', or copy the link below and open it in your browser.",
    "redirecting": "Redirecting..."
  },
  "chat_list": {
    "title": "Chat Members",
    "empty_title": "No conversations yet",
    "empty_subtitle": "Start a new conversation in any language",
    "start_new_chat": "Start a new chat",
    "date_format": "{{month}}/{{day}}",
    "date_today": "Today",
    "date_yesterday": "Yesterday",
    "menu_block_delete": "Block/Delete",
    "menu_manage_blocked": "Manage Blocked Friends",
    "menu_manage_deleted": "Manage Deleted Friends",
    "toast_deleted": "Removed from your chat list",
    "error_delete": "An error occurred while deleting. Please try again.",
    "toast_blocked": "Friend blocked",
    "error_block": "An error occurred while blocking. Please try again.",
    "manage_aria": "Manage chats",
    "search_placeholder": "Search chats...",
    "loading": "Loading...",
    "selected_count": "{{count}} selected",
    "action_block": "Block",
    "blocked_badge": "Blocked",
    "action_delete": "Delete",
    "fab_new_chat": "New Chat",
    "cancel": "Cancel",
    "delete_sheet_title": "Delete",
    "delete_sheet_desc1": "Delete {{count}} selected?",
    "delete_sheet_desc2": "They will be removed from your chat and friends lists.",
    "delete_sheet_desc3": "This does not delete it for the other person / You can restore them in Manage Deleted Friends.",
    "block_sheet_title": "Block Friend",
    "block_sheet_desc1": "Block {{count}} selected?",
    "block_sheet_desc2": "They'll move to your blocked list and can be unblocked anytime.",
    "block_sheet_desc3": "The other person won't know they've been blocked.",
    "unknown_partner": "Partner",
    "group_chat_default_name": "Group Chat",
    "fab_menu_invite": "Invite Friend",
    "find_friend_by_email": "Find friends by email",
    "fab_menu_group": "Create Group Chat",
    "invited_badge": "Invited",
    "tab_group": "Group",
    "toast_current_direct": "This is the 1:1 chat list",
    "toast_current_group": "This is the group chat list"
  },
  "group_chat": {
    "title": "Select Members",
    "header_default_name": "Group Chat",
    "inviting": "Invited",
    "invite_sheet_title": "Group Chat Invitation",
    "invite_sheet_desc": "Would you like to accept the invitation to join this chat?",
    "accept": "Accept",
    "reject": "Decline",
    "invite_rejected_toast": "Invitation declined.",
    "invite_error": "Failed to process invitation.",
    "search_placeholder": "Search by name or nickname",
    "start_button": "Start Chat ({{count}})",
    "max_members_toast": "Group chat can have up to 10 members.",
    "empty_candidates": "No eligible conversation partners found.",
    "empty_search": "No search results found.",
    "sheet_title": "Set Group Name",
    "sheet_placeholder": "Enter group chat name",
    "sheet_guide": "Leave blank to automatically name with participant names.",
    "sheet_cancel": "Cancel",
    "sheet_confirm": "Confirm",
    "creating": "Creating...",
    "err_too_few": "Group chat requires at least 3 members (including you).",
    "menu_leave": "Leave",
    "action_leave": "Leave",
    "pending_cannot_leave": "You haven't joined this invitation yet. Enter the chat and reject the invite to remove it from the list.",
    "leave_sheet_title": "Leave Group Chat",
    "leave_sheet_desc1": "Leave {{count}} selected group chat(s)?",
    "leave_sheet_desc2": "You will no longer be able to see messages in the left chat.",
    "toast_leave_success": "Left {{count}} group chat(s).",
    "toast_leave_partial": "Left {{successCount}} chat(s), {{failCount}} failed.",
    "toast_leave_fail": "Failed to leave group chat. Please try again.",
    "notif_invite_rejected_single": "{{name}} declined the invitation",
    "notif_invite_rejected_multi": "{{name}} and {{count}} other(s) declined the invitation",
    "notif_invite_rejected_none": "The invitation was declined",
    "notif_invite_accepted_single": "{{name}} joined the group",
    "notif_invite_accepted_multi": "{{name}} and {{count}} other(s) joined the group",
    "notif_invite_accepted_none": "The invitation was accepted",
    "ad_planned": "Ad space (planned)",
    "err_too_many": "Group chat can have up to 10 members.",
    "err_no_history": "Only people with 1:1 conversation history can be invited.",
    "err_unauthenticated": "Authentication required.",
    "err_unknown": "An error occurred while creating the chat. Please try again."
  },
  "setup_profile": {
    "title": "Set Up Profile",
    "subtitle": "Enter the name you'll use in chats.",
    "name_label": "Name",
    "name_required": "Required",
    "name_placeholder": "Enter your name",
    "complete": "Done",
    "saving": "Saving...",
    "error_empty": "Please enter your name",
    "error_generic": "Failed to save. Please try again."
  },
  "contacts": {
    "title": "Friends",
    "empty_title": "No friends yet.",
    "empty_desc": "People you add as friends (favorites) will appear here.",
    "loading": "Loading...",
    "toast_deleted": "Removed from your friends list",
    "toast_blocked": "Friend blocked",
    "toast_hard_deleted": "Selected friends permanently deleted",
    "manage_friends": "Manage friends",
    "error_open_chat": "Unable to open the chat room",
    "selected_count": "{{count}} selected",
    "action_delete": "Remove Friend",
    "action_block": "Block",
    "action_hard_delete": "Delete",
    "cancel": "Cancel",
    "block_sheet_title": "Block Friend",
    "block_sheet_desc1": "Block {{count}} selected?",
    "block_sheet_desc2": "They'll move to your blocked list and can be unblocked anytime.",
    "block_sheet_desc3": "The other person won't know they've been blocked.",
    "delete_sheet_title": "Delete",
    "delete_sheet_desc1": "Delete {{count}} selected?",
    "delete_sheet_desc2": "They will be removed from your chat and friends lists.",
    "delete_sheet_desc3": "(This does not delete it for the other person / You can restore them in Manage Deleted Friends.)",
    "find_friend_title": "Find Friends",
    "find_friend_desc": "Search for friends by email"
  },
  "find_friend": {
    "title": "Find Friends",
    "placeholder": "Enter an email address",
    "hint": "Search using your friend's email address",
    "invalid_email": "Please enter a valid email address",
    "searching": "Searching...",
    "no_result": "No matching user found",
    "no_result_hint": "Please check the email address and try again",
    "error": "Search failed. Please try again later",
    "error_rate_limit": "Too many searches. Please try again later",
    "rel_self": "You",
    "rel_friend": "Friend",
    "rel_requested": "Requested",
    "rel_received": "Received",
    "rel_add": "Add Friend",
    "request_sent": "Friend request sent",
    "auto_accepted": "You are now friends",
    "cooldown_soon": "You can try again shortly",
    "cooldown_minutes": "You can try again in {{minutes}} minutes",
    "cooldown_hours": "You can try again in {{hours}} hours",
    "check_notification": "Check your notifications to respond",
    "toast_already_requested": "Request already sent. We'll let you know in your inbox when they respond.",
    "err_already_sent": "Request already sent",
    "err_already_friend": "Already friends",
    "err_not_found": "User not found",
    "err_cannot_self": "You can't send a request to yourself",
    "err_send_limit": "Too many requests. Please try again tomorrow",
    "err_generic": "Request failed. Please try again later"
  },
  "nav": {
    "friends": "FR·SET",
    "home": "Home",
    "profile": "Profile"
  },
  "profile": {
    "title": "Profile",
    "my_language": "My Language",
    "lang_sheet_title": "My Language Settings",
    "lang_sheet_desc": "Select your default language.",
    "lang_sheet_country_title": "Select country",
    "lang_sheet_country_desc": "Please select your country.",
    "name_too_long": "Name can be up to 20 characters",
    "nickname_too_long": "Nickname can be up to 20 characters",
    "name_required": "Please enter your name",
    "display_name_hint": "Select your title to use when chatting below",
    "display_name": "Name",
    "display_nickname": "Nickname",
    "status_placeholder": "Status message",
    "private_info": "Private info",
    "only_you": "Only you can see",
    "email_hint": "Remember this email for re-login.",
    "save_changes": "Save Changes",
    "save_success_with_photo": "Your info and photo have been saved.",
    "save_success": "Saved",
    "save_failed": "Couldn't save. Please try again in a moment.",
    "photo_too_large": "Photo is too large. Please upload one under 30MB.",
    "photo_unsupported_format": "Unsupported format. Please use a JPG, PNG, or WebP photo.",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_none": "Not specified",
    "gender_hint_thai": "In some languages like Thai, choosing your gender\nmakes conversations feel more natural",
    "name_placeholder": "Enter your full name",
    "nickname_placeholder": "Enter a nickname",
    "city_placeholder": "City",
    "add_photo": "Add photo",
    "logout_failed": "Logout failed",
    "logout_confirm_title": "Log out?",
    "logout_confirm_in_call": "Your current call will also end.",
    "photo_deleted": "Photo deleted.",
    "uploading": "Uploading...",
    "not_saved": "Not saved",
    "options": "Options",
    "change_photo": "Change photo",
    "delete_photo": "Delete photo",
    "delete_photo_sheet_title": "Delete photo",
    "delete_photo_sheet_desc": "Delete this photo?",
    "unsaved_photo_sheet_title": "You have unsaved photos",
    "unsaved_photo_sheet_desc": "Leave anyway? Unsaved photos will be discarded.",
    "install_app": "Install App",
    "delete_account": "Delete Account",
    "delete_account_title": "Delete your account?",
    "delete_account_desc": "Deleting your account cannot be undone.\n\nYour profile, friend list, and remaining Moowoo will be deleted. Conversations are automatically deleted once all participants have been inactive for 90 days, and your name will appear as 'Unknown User'. Payment records are retained for 5 years as required by law.\n\nYou cannot sign up again with the same email for one year.",
    "delete_account_balance_warn": "Your remaining {{count}} Moowoo will also be lost.",
    "delete_account_confirm": "Delete",
    "delete_account_cancel": "Cancel",
    "delete_account_failed": "Failed to delete account. Please try again later.",
    "delete_account_success": "Your account has been deleted.",
    "install_ios_hint": "On iPhone, tap the Share button in Safari and choose 'Add to Home Screen'.",
    "install_retry_hint": "Install isn't available right now. Please refresh the page and try again.",
    "install_done": "Installed",
    "install_refresh": "Refresh",
    "install_success_hint": "MooWoo is installed.\nSwipe up on your home screen to open the app list,\nthen long-press the MooWoo icon to add it to your home screen.",
    "install_reinstall_hint": "Already installed. If you removed the app, tap Refresh below and install again.",
    "install_confirm": "OK",
    "install_already_hint": "MooWoo is already installed. Look for the MooWoo icon on your home screen or app list.",
    "install_unavailable_hint": "If the install dialog doesn't open, pull down to refresh the page and tap Install App again."
  },
  "new_chat": {
    "header": "Chat Language Settings",
    "my_language": "My Country / Language",
    "select_placeholder": "Select language...",
    "translation_tone": "Translation Tone",
    "polite": "Polite",
    "casual": "Casual",
    "basic": "Basic",
    "tone_hint": "Polite and Casual use a bit more MW.",
    "toast_tone_basic": "Fastest translation,\nkeeping the original tone",
    "toast_tone_polite": "Courteous translation.\nGreat for first meetings",
    "toast_tone_casual": "Friendly and easygoing,\nlike talking to a close friend",
    "start_invite": "Start / Invite Chat"
  },
  "chat_conversation": {
    "error_load_failed": "Couldn't load the conversation",
    "error_no_access": "This chat room has been deleted or is inaccessible.",
    "error_blocked": "This is a conversation with a blocked user.",
    "invite_not_accepted": "Please accept the invite first",
    "error_tts_unsupported": "This browser does not support voice features.",
    "error_tts_no_voice": "This device has no {{langName}} voice, so it can't be played. Please install the voice pack in your system settings.",
    "error_tts_no_secondary_lang": "Language information for the second translation could not be found.",
    "error_tts_unsupported_lang": "This language is not supported for voice playback.",
    "error_lang_save": "Failed to save language",
    "toast_input_lang_set": "Input: {{langName}}",
    "toast_primary_lang_set": "Translation 1: {{langName}}",
    "toast_secondary_lang_set": "Translation 2: {{langName}}",
    "toast_secondary_lang_off": "Translation 2 off",
    "toast_copied": "Copied",
    "toast_copy_failed": "Failed to copy",
    "toast_mic_hint": "Tap the microphone on your keyboard to input by voice",
    "toast_mic_hint_ios_label": "No mic?",
    "toast_mic_hint_ios_path": "Settings → General → Keyboard → Enable Dictation",
    "error_send_failed": "Failed to send message.",
    "error_send_failed_restored": "Failed to send. Your message has been restored to the input field.",
    "translation_unavailable": "There is a connection issue with the AI server.\nPlease try again later.",
    "header_loading": "Loading...",
    "header_unknown_user": "Unknown user",
    "date_today": "Today",
    "date_yesterday": "Yesterday",
    "loading_messages": "Loading messages...",
    "empty_conversation": "No conversation yet. Say hello!",
    "menu_select_delete": "Select to delete",
    "delete_for_me": "Delete for me",
    "delete_for_everyone": "Delete for everyone",
    "deleted_message": "This message was deleted",
    "delete_cancel": "Cancel",
    "menu_copy": "Copy",
    "menu_save": "Save",
    "toast_tone_polite": "Translating politely",
    "toast_tone_casual": "Translating casually",
    "toast_tone_basic": "Basic translation",
    "toast_tts_on": "I'll read new messages aloud (check device volume if no sound)",
    "toast_tts_off": "Auto-read turned off",
    "input_placeholder": "Type a message...",
    "sheet_lang_title": "Chat partner's language 1",
    "sheet_lang_desc": "Select the first language for this chat room.",
    "sheet_input_lang_title": "My input language",
    "sheet_input_lang_desc": "Select the language you will type in.",
    "sheet_lang2_title": "Chat partner's language 2 (optional)",
    "sheet_lang2_desc": "If needed, select a second language for this chat room.",
    "feature_coming_soon": "This feature is coming soon.",
    "error_file_too_large": "File size exceeds 30MB limit.",
    "error_gif_too_large": "GIF animations can be up to 5MB.",
    "error_unsupported_file_type": "Unsupported file format.",
    "error_video_too_large": "This video is too large. Try a shorter clip or a lower recording quality",
    "error_video_too_long": "This video is too long. Please send a clip of about 30 seconds or less",
    "error_unsupported_video": "Unsupported or unplayable video format.",
    "error_video_unsupported_format": "This video type can't be previewed. Attach it as a file so the other person can download it",
    "warn_video_hevc": "This video uses the HEVC format and may not play on some devices. For better compatibility, go to Settings → Camera → Formats on iPhone and choose \"Most Compatible\".",
    "video_thumb_fallback": "Couldn't create a preview, but your video will still be sent",
    "upload_failed": "Send failed",
    "retry": "Retry",
    "delete": "Delete",
    "attachment_title": "Attach file",
    "attachment_photo": "Photo",
    "attachment_file": "Document",
    "attachment_video": "Video",
    "saving": "Saving...",
    "saved": "Saved.",
    "save_failed": "Failed to save.",
    "attachment_expired": "This file has expired",
    "toast_attachment_guide": "Press and hold to delete or save",
    "expiry_until_date": "Until {{date}}",
    "expiry_days_left": "{{days}}d left",
    "expiry_today": "Expires today",
    "attachment_image_alt": "Attached image",
    "attachment_video_thumb_alt": "Video thumbnail",
    "cancel_attachment": "Cancel attachment",
    "moowoo_empty_title": "You're out of MooWoo.",
    "moowoo_empty_desc": "Please buy more at the MooWoo Store.",
    "moowoo_empty_toast": "You're out of MooWoo.\nPlease buy more at the MooWoo Store."
  },
  "invite": {
    "share_sms": "MooWoo chat invitation: {{inviteLink}}",
    "share_email_subject": "MooWoo chat invitation",
    "share_email_body": "Join the chat with the link below:\n{{inviteLink}}",
    "title": "Invite someone to chat",
    "description": "They can join right from their browser — no app install needed.",
    "copied": "Copied!",
    "copy_link": "Copy link",
    "share_message": "Message",
    "share_email": "Email",
    "share_qr": "QR Code",
    "close": "Close",
    "select_lang_placeholder": "Select the language the invitee uses",
    "select_lang_guide": "The recipient will see this language first. They can change it anytime",
    "err_select_lang_first": "Please select the first language to speak",
    "link_placeholder": "Select a language to create your link",
    "qr_title": "Scan to Join",
    "qr_desc": "Point your camera at the QR code to open the chat room."
  },
  "friends_sheet": {
    "confirm_default": "Confirm",
    "cancel_default": "Cancel",
    "loading": "Loading...",
    "blocked_title": "Blocked Friends",
    "blocked_desc": "Unblock to chat again",
    "blocked_empty": "No blocked friends",
    "unblock_btn": "Unblock",
    "unblock_toast": "You unblocked {{name}}.",
    "deleted_title": "Deleted Friends",
    "deleted_desc": "Restore to chat again or add as a friend",
    "deleted_empty": "No deleted friends",
    "restore_btn": "Restore",
    "restore_toast": "Restored {{name}}",
    "restore_error": "Failed to restore. Please try again."
  },
  "join_via_link": {
    "invited_title": "{{name}} invited you to chat",
    "invited_desc": "Talk in your own language — MooWoo translates automatically for both of you.",
    "join_button": "Join Chat",
    "invalid_link": "This link is no longer valid",
    "go_home": "Go to Home",
    "email_label": "Email Address",
    "email_placeholder": "example@email.com",
    "email_invalid": "Please enter a valid email address.",
    "error_dead_link": "Invalid invite link.",
    "error_timeout": "Verification time has expired. Please reopen the invite link and try again.",
    "error_failed": "An error occurred during processing. Please try again.",
    "footer_note1": "Just one email verification to get started.",
    "footer_note2": "Your conversations are not used for AI training.",
    "required": "*Required",
    "already_member": "You are already logged in as {{name}}.",
    "continue_as_me": "Continue as me",
    "use_other_account": "Start with another account",
    "self_invite": "This is my own invite link.",
    "google_login": "Sign in with Google",
    "email_required": "Please enter your email address.",
    "google_preparing": "Opening soon. Please continue with your email for now."
  },
  "friend_profile": {
    "page_title": "{{name}}'s Profile",
    "loading": "Loading profile...",
    "error_not_found": "Profile not found.",
    "save": "Save",
    "cancel": "Cancel",
    "nickname_save_failed": "Failed to save. Please try again.",
    "nickname_instruction": "Please enter a new name to edit.",
    "remove_nickname": "Remove nickname"
  },
  "moowoo": {
    "unit": "MW",
    "unitShort": "MW",
    "badgeAria": "My MooWoo stock",
    "myBalance": "My Stock",
    "availablePower": "Available",
    "messagesLeft": "About {{count, moowoo}} messages left",
    "emptyHint": "You need MooWoo to send messages",
    "noteLow": "You're running low on MW.",
    "noteCritical": "You'll run out of MW soon.",
    "noteEmpty": "You've used all your MW.",
    "expiresOn": "Expires {{date}}",
    "expires_item": "{{label}} {{amount}} {{unit}} · Expires {{date}}",
    "label_free": "Free",
    "label_paid": "Paid",
    "noteLowAction": "You're running low on MooWoo. Top up to keep chatting.",
    "noteEmptyAction": "You're out of MW. Top up to keep chatting.",
    "pageTitle": "MooWoo",
    "back": "Back",
    "topUp": "MooWoo Store",
    "packBenefit": "About 8 months at 30/day (Basic tone)",
    "packCaption": "Used up little by little as you chat. About 1 MooWoo per short message; Polite and Casual use a bit more.",
    "expiry": "Valid for 9 months from purchase",
    "taxNote": "",
    "payButton": "Buy MooWoo",
    "comingSoon": "Payment is coming soon.",
    "gift": {
      "sheetTitle": "MW",
      "receivedFrom": "{{name}} sent you {{amount}} MooWoo",
      "receivedAtWithExpiry": "{{createdAt}} (Claim by {{expiresAt}})",
      "claim": "Claim",
      "sendGift": "Send MW",
      "toName": "To {{name}}",
      "selectReceiver": "Select recipient",
      "totalBalance": "Balance {{amount}} MW",
      "sendable": "Sendable {{amount}} MW",
      "balanceAfter": "Balance after sending {{from}} → {{to}} MW",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "errMinAmount": "Enter at least 1 MW",
      "errInsufficient": "Exceeds sendable amount",
      "errExceedsSendable": "Exceeds sendable amount",
      "lockNoSendable": "No sendable MooWoo",
      "lockPaidExpired": "Paid MW expired",
      "sending": "Sending...",
      "successMessage": "MW sent successfully.",
      "errUnauthenticated": "Authentication required.",
      "errInvalidAmount": "Invalid amount.",
      "errSelfGift": "You cannot send MW to yourself.",
      "errNotParticipant": "Not a participant of this conversation.",
      "errPaidExpired": "Paid MW has expired.",
      "errInsufficientPaid": "Insufficient paid MooWoo.",
      "errUnknown": "An error occurred.",
      "claimSuccess": "MW received.",
      "errGiftNotFound": "MW not found.",
      "errNotRecipient": "You are not the recipient.",
      "errAlreadyClaimed": "This MW was already claimed.",
      "errGiftExpired": "This MW has expired.",
      "reject": "Decline",
      "confirmReject": "Confirm decline",
      "rejectSuccess": "MW declined.",
      "errRejectUnknown": "Failed to decline MW.",
      "errAlreadyProcessed": "This MW has already been processed.",
      "processing": "Processing...",
      "giftExpiredNotice": "Expired",
      "selectRecipientTitle": "Select a member",
      "noMembersAvailable": "No members available"
    },
    "history": {
      "pageTitle": "MooWoo History",
      "empty": "No history yet",
      "emptyFiltered": "No history for this category",
      "loading": "Loading",
      "typeCharge": "Purchased MooWoo",
      "typeGrantFree": "Free MooWoo",
      "typeGiftIn": "Received MooWoo",
      "typeGiftRefundExpire": "Unclaimed Return (Expired)",
      "typeGiftRefundReject": "Unclaimed Return (Declined)",
      "typeRefund": "Refund",
      "typeUse": "Translation",
      "typeGiftOut": "Sent MooWoo",
      "typePeriodExpire": "Expired",
      "typeExpire": "Expired",
      "entry": "View history",
      "translationCount_one": "{{count}} translation",
      "translationCount_other": "{{count}} translations",
      "itemCount_one": "{{count}} tx",
      "itemCount_other": "{{count}} txs",
      "loadNextChunk": "Show {{count}} more",
      "loadNextChunk20": "Show 20 more ({{remain}})",
      "showInitialChunk": "Show first 20",
      "viewAllTotal": "View all ({{total}})",
      "viewAllLimitToast": "Only up to 200 items can be viewed at once",
      "unknownUser": "Unknown",
      "summaryReceived": "Received",
      "summaryUsed": "Used",
      "summaryRemaining": "Remaining",
      "summaryFreeLabel": "Free",
      "summaryPaidLabel": "Paid",
      "expiresUntil": "(until {{date}})"
    }
  },
  "checkout": {
    "title": "Checkout",
    "orderSummary": "Order Summary",
    "total": "Total",
    "priceNote": "The price shown is the final amount charged",
    "termsAgree": "I agree to the payment and refund policy (non-refundable once used)",
    "payWithCard": "Card & Other Payments",
    "payWithPayPal": "Pay with PayPal",
    "linkTerms": "Terms of Service",
    "linkPrivacy": "Privacy Policy",
    "linkTermsAria": "Open Terms of Service",
    "linkPrivacyAria": "Open Privacy Policy",
    "termsModalTitle": "Terms of Service",
    "closeModal": "Close",
    "guideTitle": "Guide"
  },
  "paymentResult": {
    "title": "Payment Result",
    "successTitle": "Payment Successful",
    "successDesc": "Your MooWoo recharge has been processed.\nEnjoy the service!",
    "failTitle": "Payment Failed",
    "failDesc": "A problem occurred during payment.\nPlease try again later.",
    "cancelTitle": "Payment Canceled",
    "cancelDesc": "The payment process was canceled.\nIf the problem persists, please contact support.",
    "btnMoowoo": "To MooWoo Store",
    "btnRetry": "Try Again",
    "btnHome": "Go Home"
  },
  "common": {
    "install_guide_default": "Tap the \"Get the app\" button above",
    "install_guide_ios": "Tap the Share button at the bottom, then choose \"Add to Home Screen\".",
    "install_guide_inapp": "You can't install directly here. Tap \"Get the app\" above to open in Chrome",
    "install_app_short": "Get the app",
    "install_address_bar_hint": "Tap the install icon on the right side of your browser's address bar. If you don't see it, installation isn't available in a private window — please open this page in a regular window.",
    "close": "Close",
    "logout": "Log Out",
    "logging_out": "Logging out…",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "preview_sender_me": "Me: ",
    "preview_photo": "Photo",
    "preview_video": "Video",
    "preview_file": "Document",
    "preview_no_messages": "No messages",
    "preview_invite_pending": "Accept the invite to view",
    "preview_gift_sent_by_me": "Sent MW",
    "preview_gift_received_by_me": "{{sender}} sent MW",
    "preview_gift_sent_by_other": "{{sender}} sent MW to {{receiver}}",
    "preview_gift_sent_by_other_fallback": "{{sender}} sent MW",
    "preview_gift_rejected": "{{sender}} declined MW",
    "preview_gift_rejected_no_name": "MW declined",
    "preview_gift_claimed": "{{sender}} received MW",
    "preview_gift_claimed_no_name": "MW received",
    "preview_gift_expired": "MW was returned as it expired"
  },
  "video_viewer": {
    "loading": "Loading video...",
    "download_original": "Download original",
    "downloading": "Downloading...",
    "downloaded": "Downloaded",
    "download_failed": "Download failed",
    "playback_failed_guide": "If the codec is not supported, the video may not play. In that case, try downloading the original video.",
    "url_error": "Unable to load video. Please download the original to view it.",
    "default_title": "Video",
    "default_filename": "video.mp4"
  },
  "group_info": {
    "title": "Group Info",
    "members_title": "Members ({{count}})",
    "pending_members_title": "Invited ({{count}})",
    "leave_button": "Leave Group",
    "owner_badge": "Host",
    "me_badge": "Me",
    "leave_confirm_title": "Leave Group",
    "leave_confirm_desc": "If you leave, this chat will disappear from your list and you will need a new invitation to rejoin.",
    "leave_confirm_btn": "Leave",
    "leave_cancel_btn": "Cancel",
    "leave_success_toast": "You left the group chat.",
    "leave_error_toast": "Failed to leave the group chat.",
    "invite_button": "Invite"
  },
  "group_invite": {
    "title": "Invite Members",
    "count_display": "{{count}}/10",
    "count_subtext": "Includes pending invites",
    "search_placeholder": "Search name",
    "invite_btn": "Invite",
    "invite_btn_with_count": "Invite ({{count}})",
    "no_candidates": "No members available to invite.",
    "err_room_full_limit": "You can invite up to 10 members in total.",
    "invite_success": "Invited {{count}} member(s).",
    "err_room_full": "The room has reached maximum capacity (10 members).",
    "err_already_member": "Already a member of this chat.",
    "err_kicked_owner_only": "Only the host can re-invite removed members.",
    "err_no_direct_history": "You can only invite friends with 1:1 chat history.",
    "err_no_permission": "Only active members can invite others.",
    "err_unauthenticated": "Authentication required.",
    "err_not_active": "You are not an active member.",
    "err_no_targets": "Please select members to invite.",
    "err_general": "An error occurred while inviting members."
  },
  "system_message": {
    "invited_single": "{{actor}} invited {{target}}",
    "invited_multiple": "{{actor}} invited {{target}} and {{count}} other(s)",
    "joined": "{{actor}} joined the chat",
    "left": "{{actor}} left the chat",
    "gift_sent": "{{sender}} sent MW to {{receiver}}",
    "gift_rejected": "{{name}} declined MW",
    "gift_claimed": "{{name}} received MW",
    "gift_expired_to_sender": "MW sent to {{name}} was returned as it expired",
    "gift_expired_to_receiver": "MW sent by {{name}} was returned as it expired",
    "unknown_user": "Unknown user"
  },
  "notification": {
    "group_invite_received": "{{name}} invited you",
    "group_invite_received_anonymous": "New invitation received",
    "group_invite_received_group": "{{name}} invited you to a group chat",
    "group_invite_received_direct": "{{name}} invited you to a chat",
    "moowoo_gift_expired": "{{amount}} MW returned",
    "moowoo_gift_rejected": "{{name}} declined MW",
    "moowoo_gift_rejected_more": "{{name}} declined MW (+{{count}} more)",
    "unnamed_room": "Unnamed group chat",
    "close": "Close",
    "group_invite_accepted": "{{name}} accepted the invitation",
    "group_invite_rejected": "{{name}} declined the invitation",
    "friend_request_received": "{{name}} sent you a friend request",
    "friend_request_accepted": "You're now friends with {{name}}. Say hello!",
    "friend_request_rejected": "Request closed. You can send it again from Find Friends",
    "friend_accept": "Accept",
    "friend_reject": "Decline",
    "friend_accepted": "You are now friends",
    "friend_rejected": "Request declined",
    "friend_state_accepted": "Accepted",
    "friend_state_rejected": "Declined",
    "friend_state_handled": "Handled",
    "friend_already_handled": "This request has already been handled",
    "friend_action_error": "Action failed. Please try again later"
  },
  "avatar_cropper": {
    "title_avatar": "Adjust Avatar",
    "title_photo": "Adjust Photo",
    "cancel": "Cancel",
    "reset": "Reset",
    "save": "Save",
    "saving": "Saving...",
    "unsupported_format": "Unsupported image format",
    "process_error": "An error occurred while processing the image."
  },
  "avatar_picker": {
    "title": "Choose Avatar",
    "tab_dog": "Dogs",
    "tab_man": "Men",
    "tab_woman": "Women",
    "tab_photo": "My Photo",
    "select_photo": "Select photo",
    "change_photo": "Change photo",
    "confirm_title": "Use this avatar?",
    "cancel": "Cancel",
    "save": "Save",
    "save_success": "Saved",
    "back_aria": "Go back",
    "err_size": "Photo is too large. Please upload one under 30MB.",
    "err_format": "Unsupported format. Please use a JPG, PNG, or WebP photo.",
    "err_save": "Couldn't save. Please try again in a moment."
  },
  "temp_profile_banner": {
    "message": "Your name and profile photo are temporary.",
    "action": "Change in profile",
    "close_aria": "Dismiss banner"
  },
  "push_prompt_banner": {
    "title": "Turn on notifications so you don't miss messages or calls",
    "desc": "We'll let you know right away, even when the app is closed.",
    "btn_enable": "Turn on",
    "btn_later": "Not now",
    "close_aria": "Dismiss notification prompt",
    "toast_success": "Notifications are on.",
    "toast_denied": "Notifications are blocked in your browser. Please allow them in your browser settings.",
    "toast_default": "The notification permission prompt did not appear. Please click the lock icon in the address bar and change notifications to 'Allow'.",
    "toast_sw_timeout": "Notification setup is taking longer than expected. Please try again in a moment.",
    "toast_failed": "Couldn't turn on notifications. Please try again later."
  },
  "settings": {
    "title": "Settings",
    "back_aria": "Go back",
    "section_notifications": "Notifications",
    "push_message": "Messages",
    "push_invite": "Chat Invites",
    "push_gift": "MooWoo Gifts",
    "save_error": "Failed to save settings. Please try again in a moment.",
    "allow_notifications": "Allow Notifications",
    "unsupported_push": "Web push notifications are not supported in this browser.",
    "blocked_push": "Notifications are blocked. Tap the icon at the left of the address bar, then allow notifications under 'Permissions' or 'Site settings'.",
    "blocked_push_toast": "The browser has blocked notifications. Please click the lock icon in the address bar and change notifications to 'Allow'.",
    "error_permission_denied": "Notification permission was not granted.",
    "error_sw_timeout": "Notification setup is taking longer than expected. Please try again in a moment.",
    "error_subscribe_failed": "Failed to subscribe to notifications. Please try again in a moment.",
    "error_unsubscribe_failed": "Failed to unsubscribe from notifications. Please try again in a moment.",
    "error_vapid_missing": "Push configuration key (VAPID) is missing.",
    "ios_homescreen_guide": "To receive notifications, add this app to your Home Screen. Tap the Share button at the bottom of Safari, then select 'Add to Home Screen'.",
    "notif_guide_title": "Not getting notifications, or only a sound?",
    "notif_guide_android_popup_title": "Sound plays but nothing drops down from the top",
    "notif_guide_android_missing_title": "No notifications at all",
    "notif_guide_android_pwa_popup": "Phone Settings → Apps → MooWoo → Notifications → Notification categories → General → turn on 'Show as pop-up'.",
    "notif_guide_android_pwa_category": "If 'Notification categories' is not shown, first turn on Settings → Notifications → Advanced settings → 'Manage notification categories for each app'.",
    "notif_guide_android_pwa_missing": "On the same MooWoo notification screen, turn on 'Allow notifications' and turn off battery saver.",
    "notif_guide_android_browser_popup": "Go to your phone's Settings → Notifications → App notifications → {{browser}} → chat.moowoo.app and turn on 'Pop-up display' (also called 'Allow notification pop-ups').",
    "notif_guide_android_browser_missing": "On the same screen, allow notifications for chat.moowoo.app and turn off battery saver.",
    "notif_guide_android_note": "※ Menu names may differ slightly by phone model.",
    "notif_guide_windows": "If notifications don't arrive, turn on {{browser}} notifications in Windows settings. If Focus mode (Do Not Disturb) is on, turn it off.",
    "notif_guide_mac": "If notifications don't arrive, turn on {{browser}} notifications in System Settings. If Focus mode (Do Not Disturb) is on, turn it off.",
    "notif_test_label": "Notification test",
    "notif_test_button": "Send",
    "notif_test_sending": "Sending",
    "notif_test_title": "MooWoo",
    "notif_test_body": "Your notifications are working.",
    "notif_test_sent": "Test notification sent. Please check if it arrives shortly.",
    "notif_test_failed": "Failed to send the test notification. Please try again later.",
    "browser_samsung": "Samsung Internet",
    "browser_whale": "Whale",
    "browser_edge": "Edge",
    "browser_opera": "Opera",
    "browser_firefox": "Firefox",
    "browser_chrome": "Chrome",
    "browser_safari": "Safari",
    "browser_generic": "browser",
    "inapp_guide_android": "Notifications cannot be enabled in in-app browsers. Please switch to external Chrome.",
    "inapp_guide_android_failed": "Failed to open Chrome. Please copy the link and paste it into Chrome.",
    "inapp_guide_ios": "Notifications cannot be enabled in in-app browsers. Please copy the link and paste it into Safari.",
    "inapp_guide_generic": "Notifications cannot be enabled in in-app browsers. Please use an external browser.",
    "inapp_btn_open_chrome": "Open in Chrome",
    "inapp_btn_copy_url": "Copy Link",
    "inapp_copy_success": "Link copied. Please paste it into your external browser address bar.",
    "inapp_copy_failed": "Failed to copy link. Please touch and hold the address below to copy.",
    "inapp_copy_manual_guide": "Touch and hold the address below to copy:",
    "inapp_open_failed_toast": "Failed to open external browser. Please copy the link.",
    "section_legal": "Terms & Policy",
    "privacy_policy": "Privacy Policy",
    "terms_of_service": "Terms of Service"
  },
  "legal": {
    "privacy_title": "Privacy Policy",
    "terms_title": "Terms of Service"
  },
  "notification_box": {
    "title": "Notifications",
    "empty": "No notifications yet.",
    "empty_desc": "Notifications received in the last 30 days are kept here.",
    "back_aria": "Go back",
    "bell_aria": "Notification box",
    "mark_all_read": "Read all",
    "mark_all_read_aria": "Mark all notifications as read",
    "unread_badge_aria": "{{count}} unread notifications"
  },
  "notification": {
    "moowoo_gift_expired": "The claim period for the {{amount}} MooWoo gift has expired",
    "moowoo_gift_rejected": "{{name}} declined the MooWoo gift",
    "group_invite_received_group": "{{name}} invited you to a group chat",
    "group_invite_received_direct": "{{name}} invited you to a 1:1 chat",
    "group_invite_received_anonymous": "You received a chat invitation",
    "group_invite_accepted": "{{name}} accepted your invitation",
    "group_invite_rejected": "{{name}} declined your invitation",
    "friend_request_received": "{{name}} sent you a friend request",
    "friend_request_accepted": "You're now friends with {{name}}. Say hello!",
    "friend_request_rejected": "Request closed. You can send it again from Find Friends",
    "friend_state_accepted": "Accepted",
    "friend_state_rejected": "Declined",
    "friend_state_handled": "Completed",
    "friend_accept": "Accept",
    "friend_reject": "Decline",
    "friend_already_handled": "This friend request has already been processed",
    "friend_action_error": "Failed to process request. Please try again later",
    "friend_accepted": "Friend request accepted",
    "friend_rejected": "Friend request declined",
    "friend_fetch_retry_hint": "Failed to load friend request details. Please try again later",
    "unknown_user": "Unknown",
    "close": "Close",
    "edit": "Edit",
    "cancel": "Cancel",
    "select_all": "Select All",
    "deselect_all": "Deselect All",
    "selected_count": "{{count}} selected",
    "action_delete": "Delete",
    "delete_confirm_title": "Delete Notifications",
    "delete_confirm_desc": "Delete {{count}} selected notifications?\nDeleted notifications cannot be recovered.",
    "delete_success": "Notifications deleted",
    "delete_error": "Failed to delete notifications. Please try again later",
    "cannot_delete_pending_friend": "Please accept or decline the pending friend request first"
  },
  "call": {
    "group_call_title": "Group voice call",
    "group_incoming": "Incoming group voice call",
    "group_call_title_video": "Group video call",
    "group_incoming_video": "Incoming group video call",
    "group_waiting": "Waiting for others to join…",
    "group_connecting": "Connecting…",
    "group_participants": "{{count}} in call",
    "group_call_in_progress": "Group voice call in progress",
    "group_call_in_progress_video": "Group video call in progress",
    "back_to_grid": "Back to grid",
    "group_double_tap_hint": "Double tap to zoom in",
    "group_join": "Join",
    "group_call_full": "This call is full",
    "group_me": "Me",
    "group_peer_connecting": "Connecting",
    "group_peer_joined": "{{name}} joined",
    "group_peer_left": "{{name}} left",
    "group_peer_lost": "{{name}} got disconnected",
    "group_peers_left": "{{name}} and {{count}} others left",
    "group_alone_countdown": "Everyone left · Call ends in {{seconds}}s",
    "group_no_answer": "No one answered",
    "group_ended_alone": "Everyone left, so the call ended",
    "group_left_while_away": "You were disconnected and left the call",
    "group_cancelled": "The caller cancelled the call",
    "group_unstable": "Your connection is unstable",
    "tap_to_unmute": "Tap to unmute",
    "minimize": "Minimize",
    "expand": "Expand",
    "unavailable_partner": "Unable to start a call with this user.",
    "mic_permission_denied": "Microphone permission is required. Please allow microphone access in your browser settings.",
    "calling": "Connecting...",
    "incoming": "Incoming voice call",
    "incoming_video": "Incoming video call",
    "connected": "In call",
    "in_progress": "Call in progress.\nPressing back again\nmay end the call.",
    "ended": "Call ended.",
    "accept": "Accept",
    "accept_voice": "Answer with voice",
    "accept_video": "Answer with video",
    "decline": "Decline",
    "end": "End",
    "failed": "Failed to connect call.",
    "connection_failed": "Call connection failed.",
    "connection_lost": "Call ended due to a lost network connection.",
    "no_answer": "No answer.",
    "busy": "The user is currently busy.",
    "declined": "The user declined the call.",
    "canceled": "Call canceled.",
    "already_ended": "This call has already ended.",
    "recovery_failed": "Failed to retrieve call connection information.",
    "preparing_connection": "Preparing connection",
    "log_missed": "Missed call",
    "log_canceled": "Canceled call",
    "log_no_answer": "No answer",
    "log_declined": "Call declined",
    "log_busy": "User busy (Not connected)",
    "log_failed": "Call failed",
    "log_ended": "Voice call {{duration}}",
    "log_ended_video": "Video call {{duration}}",
    "blocked_attempt": "Call attempt from a blocked contact",
    "mute": "Mute",
    "speaker": "Speaker",
    "earphones": "Earphones",
    "video": "Video",
    "translate": "Translate",
    "peer_muted": "Other party is muted",
    "muted_indicator": "Muted",
    "feature_in_verification": "Feature is under verification.",
    "device_reconnected": "Audio device reconnected",
    "device_reconnect_failed": "Failed to reconnect audio device",
    "speaker_switched_named": "Output device: {{device}}",
    "speaker_switched": "Output device switched.",
    "speaker_switch_failed": "Unable to switch output device.",
    "speaker_not_supported": "In-app speaker switching is not supported on this browser. Please use your device's volume buttons or connect earphones.",
    "mic_locked_banner": "Microphone is locked. Press the key (Fn+F8, etc.) to unlock it",
    "mic_locked_help_btn": "How to fix",
    "mic_guide_title": "How to unlock microphone",
    "mic_guide_close_aria": "Close",
    "mic_guide_step1": "Press the microphone key on your keyboard (Fn+F8, Fn+F4, etc. depending on model)",
    "mic_guide_step2": "Right-click speaker icon at bottom right → Sound settings → Input → Unmute microphone",
    "mic_guide_step3": "Click lock icon on address bar → Check that microphone permission is set to Allow",
    "mic_guide_step4": "If it still does not work, please end the call and reconnect",
    "mic_guide_close_btn": "Close",
    "mic_reconnected_named": "Microphone reconnected: {{name}}",
    "mic_changed_named": "Microphone changed: {{name}}",
    "mic_changed": "Microphone changed",
    "redial_title": "Voice call",
    "redial_video_title": "Video call",
    "redial_confirm": "Call {{name}} again?",
    "redial_connect": "Call",
    "camera_permission_denied": "Camera access is off. Please allow camera in your phone settings.",
    "camera_permission_denied_desktop": "Camera permission is turned off.\nClick the icon on the left of the address bar and set Camera to 'Allow'.",
    "camera_unavailable": "Can't turn on the camera. Check if another app is using it.",
    "camera_no_picture": "Your camera isn't showing a picture.\nCheck the camera cover, then turn the camera button off and on again.",
    "camera_no_picture_chrome": "Your camera isn't showing a picture.\n① Check that the camera cover is open.\n② If it still doesn't work, go to Chrome Settings → Privacy and security → Site settings → Camera and choose another camera.",
    "camera_no_picture_edge": "Your camera isn't showing a picture.\n① Check that the camera cover is open.\n② If it still doesn't work, go to Edge Settings → Cookies and site permissions → Camera and choose another camera.",
    "camera_switched": "Switched to '{{name}}' because the camera showed no picture.\nWe'll use this camera first in future calls too.",
    "camera_another": "another camera",
    "camera_not_ready": "Camera is getting ready. Please try again in a moment.",
    "peer_video_unsupported": "The other person's app is an older version, so video calls aren't available.\nPlease ask them to fully close the app and open it again.",
    "camera_switch_facing": "Switch camera",
    "camera_switch_failed": "Couldn't switch cameras, so we went back to the previous one.",
    "camera_switch_lost": "Couldn't switch cameras, so the camera was turned off.\nPlease tap the video button again.",
    "camera_switch_reconnecting": "Reconnecting. Please try again in a moment.",
    "peer_recovering": "The other person is reconnecting ({{seconds}}s)",
    "peer_recover_failed": "Couldn't reconnect. Please call again.",
    "unstable_ended": "The call ended due to an unstable connection. Please call again.",
    "self_recovering": "Reconnecting…",
    "net_changed_self": "Your connection changed. Reconnecting your call… Please don't hang up.",
    "net_changed_peer": "The other person's connection changed. Reconnecting… Please don't hang up.",
    "peer_unstable": "The other person's connection is unstable. Please stay on the line.",
    "reconnected": "Reconnected.",
    "rotate_screen": "Rotate screen",
    "rotate_guide": "Rotate your phone sideways.\nIf it doesn't rotate, turn on\nAuto-rotate in Quick Settings.",
    "rotate_unsupported": "Screen rotation is\nnot available on this device."
  },
  "alert_modal": {
    "confirm": "Confirm"
  },
  "attachment_sheet": {
    "close_sheet": "Close attachment sheet"
  },
  "error_boundary": {
    "title": "A temporary problem has occurred.",
    "desc": "Please try again in a moment.",
    "refresh": "Refresh"
  },
  "gift_sheet": {
    "close_sheet": "Close MooWoo sheet"
  },
  "image_viewer": {
    "default_alt": "Photo",
    "original_alt": "Original photo",
    "default_filename": "photo.jpg"
  },
  "read_indicator": {
    "read": "Read",
    "unread": "Unread"
  },
  "group_chat_list": {
    "default_group_name": "Group Chat"
  },
  "new_group_chat": {
    "back_aria": "Go back",
    "deselect_member_aria": "Deselect"
  },
  "message_preview": {
    "gift_sent": "Sent MW",
    "gift_rejected": "MW declined",
    "gift_received": "MW received",
    "gift_expired": "MW was returned as it expired",
    "sender_me": "Me: "
  },
  "upload_file": {
    "presign_failed": "Failed to issue upload URL.",
    "download_url_failed": "Failed to issue download URL."
  },
  "profile_media": {
    "invalid_photo_slot": "Invalid photo slot.",
    "login_required": "Login required.",
    "photo_upload_failed": "Failed to upload photo.",
    "fetch_profile_failed": "Failed to load profile information.",
    "photo_save_failed": "Failed to save photo.",
    "photo_delete_failed": "Failed to delete photo.",
    "image_files_only": "Only image files can be uploaded.",
    "image_too_large": "Image file size is too large.",
    "avatar_upload_failed": "Failed to upload avatar.",
    "avatar_save_failed": "Failed to save avatar."
  }
}


